import React from 'react'
import { SBDatePicker } from '../../../../UiComponents/SBDatePicker'
import { SBAComboBox } from '../../../../UiComponents/SBADropDown'
import { AgGridReact } from 'ag-grid-react'

export const Summary = () => {
  const columnDefs = [
    { headerName: "Billing Invoice Name", field: "BillingInvoiceName"  },
    { headerName: "AUM", field: "AUM" },
    { headerName: "Approval Status", field: "ApprovalStatus" },
    { headerName: "Receivable", field: "Receivable" },
    { headerName: "Billing Plan", field: "BillingPlan" },
    { headerName: "Gross", field: "Gross" },
    { headerName: "Adjustment", field: "Adjustment" },
    { headerName: "Credit", field: "Credit" },
    { headerName: "Net", field: "Net" },
    { headerName: "Amount Received", field: "AmountReceived" },
    { headerName: "Balance", field: "Balance" },
    { headerName: "Invoice Sent", field: "InvoiceSent" },
    { headerName: "YTD Billed", field: "YTDBilled" },
  ];
  const defaultColumnDef={flex:1,autoHeaderHeight: true,wrapHeaderText: true,resizable: true,};
  return (
    <>
    <div className='row'>
       <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Invoice Date</label>
            <div>
            <SBDatePicker />
            </div>
          </div>

        </div>
        <div className='col-12 col-md-2'>
          <div>
            <label className="mb-1 label">Status</label>
            <div>
            <SBAComboBox />
            </div>
          </div>
        </div>
    </div>
     <div className="ag-theme-alpine m-1" style={{ height: '400px' }}>
     <AgGridReact columnDefs={columnDefs} rowData={[]} defaultColDef={defaultColumnDef}></AgGridReact>
   </div></>
  )
}
